/**
 * @desc 根据用户编码获取菜单
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  Array<defs.appCenter.AppDomainMenuTreeWithButtonResponseDto>
>;
export function request(
  params: API.appCenter.menu.getMenuByUserCode.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/menu/user/tree`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
